import { Header, flexRender } from '@tanstack/react-table';

import { Flex } from 'shared_DEPRECATED/components/Flex';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { Resource } from 'features/resourceBank/types';

import { Typography } from 'shared/components/Typography';

export const ResourceBankTableHeaderCell = ({
  data,
}: {
  data: Header<Resource, unknown>;
}) => {
  const { column } = data;
  const isSorted = column.getIsSorted();
  const isSortedDesc = isSorted === 'desc';
  const canSort = column.getCanSort();
  const activeSortIcon = isSortedDesc ? iconNames.sortDesc : iconNames.sortAsc;

  return (
    <Spacer size="lg">
      <div
        onClick={column.getToggleSortingHandler()}
        style={{ cursor: canSort ? 'pointer' : 'default' }}
      >
        <Flex justifyContent="flex-start" dataTestid="sessions-table-header">
          <Typography
            fontWeight="medium"
            type="small"
            whiteSpace="nowrap"
            color="black"
          >
            {flexRender(column.columnDef.header, data.getContext())}
          </Typography>
          {canSort && (
            <Spacer as="span" size="zr zr zr md">
              <Icon name={isSorted ? activeSortIcon : iconNames.sort} />
            </Spacer>
          )}
        </Flex>
      </div>
    </Spacer>
  );
};
